import Button from '../button';

const ErrorElement = ({
	message,
	className = 'w-full',
}: {
	message: string;
	className?: string;
}) => {
	return (
		<Button
			className={className}
			shape="none"
			transition="none"
			size="large"
			color="danger"
			data-test="error-element"
		>
			{message}
		</Button>
	);
};

export default ErrorElement;
